module.exports = __webpack_public_path__ + "static/media/logo.335f7681.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 149
// module chunks = 0